import {useEffect, useState} from "react";

const MOBILE_MQ = "(max-width: 768px)";

/** CSS mobile-size.css / assetDetailMobile.css 와 동일한 768px 기준 */
export function useMobileViewport() {
    const [isMobileViewport, setIsMobileViewport] = useState(
        () => typeof window !== "undefined" && window.matchMedia(MOBILE_MQ).matches
    );

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_MQ);
        const handleChange = () => setIsMobileViewport(mq.matches);
        handleChange();
        mq.addEventListener("change", handleChange);
        return () => mq.removeEventListener("change", handleChange);
    }, []);

    return isMobileViewport;
}
